// "Aktuelle Abteilung" badge — bir kayıt şu an hangi atölyede çalışılıyor
import type { CurrentSession } from '../lib/api';

function parse(sess: string | null | undefined): CurrentSession | null {
  if (!sess) return null;
  try { return JSON.parse(sess) as CurrentSession; } catch { return null; }
}

export function AbteilungBadge({ session }: { session: string | null | undefined }) {
  const s = parse(session);
  if (!s || !s.abteilung_name) {
    return <span className="text-xs text-slate-300">—</span>;
  }
  const farbe = s.abteilung_farbe ?? '#64748B';
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-xs font-medium border whitespace-nowrap"
      title={`${s.user_name ?? ''} seit ${s.running_minutes ?? 0}min`}
      style={{
        background: farbe + '22',
        borderColor: farbe + '88',
        color: darken(farbe),
      }}>
      <span className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ background: farbe }} />
      {s.abteilung_name}
      <span className="opacity-60">· {s.running_minutes ?? 0}min</span>
    </span>
  );
}

function darken(hex: string): string {
  if (!hex.startsWith('#')) return '#1E293B';
  const n = parseInt(hex.slice(1), 16);
  const r = Math.max(0, Math.round(((n >> 16) & 0xFF) * 0.45));
  const g = Math.max(0, Math.round(((n >> 8)  & 0xFF) * 0.45));
  const b = Math.max(0, Math.round((n & 0xFF) * 0.45));
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
}
